import { useStore } from 'effector-react'

import { $gifts, $totalCountOfGifts, getGifts, giftsListMounted } from './model'
import { GiftsRequest } from './types'

export const useGiftsList = () => {
  const onChangeGiftsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: GiftsRequest) => {
    giftsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }
  const loading = useStore(getGifts.pending)

  const gifts = useStore($gifts)
  const totalCountOfGifts = useStore($totalCountOfGifts)
  return { gifts, totalCountOfGifts, loading, onChangeGiftsList }
}
